<template>
    <kgr-accordion-item
        ref="accordionItem"
        :overflow="true"
        :index="index"
    >
        <template #header-left>
            <div class="kgr-postfix kgr-postfix--center kgr-postfix--tinyGutters row-min-height">
                <div class="kgr-postfix__fixed">
                    <div class="kgr-accordion__itemHeadline">
                        {{ appointmentTitle }}
                    </div>
                </div>
                <div
                    v-if="isOverwritten"
                    class="kgr-postfix__fixed"
                >
                    <kgr-icon
                        icon-class="warning"
                        :title="$t('Dieser Termin hat Änderungen')"
                        class="kgr-postfix__icon"
                    />
                </div>
                <div class="kgr-postfix__fixed kgr-accordion__itemHeadline row-extra-margin">
                    <button
                        v-show="!showAddParticipant"
                        :title="$t('Teilnehmer hinzufügen')"
                        class="kgr-color--accent"
                        @click="editParticipant"
                    >
                        <kgr-icon
                            icon-class="add"
                            class="add-icon"
                            small
                        />
                        <kgr-icon
                            icon-class="user"
                            class="add-icon-user"
                            small
                        />
                    </button>
                    <div
                        v-if="showAddParticipant"
                        class="search-container"
                        @click.stop
                    >
                        <kgr-offering-live-search-result-preview
                            :club-id="clubId"
                            :offering="offering"
                            @member-selected="(data) => acceptBookingByMemberId(data.id)"
                        />
                    </div>
                    <button
                        v-show="showAddParticipant"
                        :title="$t('Abbrechen')"
                        class="clear-icon"
                        @click.stop="cancelAddParticipant"
                    >
                        <kgr-icon icon-class="clear" />
                    </button>
                </div>
                <div class="kgr-postfix__fixed kgr-postfix__fluid"></div>
                <div
                    v-if="appointment.attendanceAbsentCount !== null"
                    class="kgr-postfix__fixed kgr-postfix__fluid"
                    style="text-align: right"
                >
                    {{ $t('booking.attendeeStatus') }}: <span style="color: green"> {{ appointment.attendancePresentCount }} </span>
                    / <span> {{ appointment.attendanceNoneCount }}</span>
                    / <span style="color: red">{{ appointment.attendanceAbsentCount }}</span>
                </div>
            </div>
        </template>

        <div v-if="active">
            <div class="kgr-row">
                <button
                    v-if="isCancelled"
                    class="kgr-button kgr-button--accent"
                    @click="openConfirmReactivationModal()"
                >
                    {{ $t('Diesen Termin reaktivieren') }}
                </button>
                <button
                    v-else
                    class="kgr-button kgr-button--accent"
                    @click="openConfirmCancellationModal()"
                >
                    {{ $t('Diesen Termin absagen') }}
                </button>
                <button
                    v-show="!appointment.appointmentOverride || (appointment.appointmentOverride && !appointment.appointmentOverride.isCanceled)"
                    class="kgr-button kgr-button--accent"
                    @click="showEdit = !showEdit"
                >
                    {{ $t('Diesen Termin bearbeiten') }}
                </button>
                <button
                    v-if="showAttendanceListButton()"
                    class="kgr-button kgr-button--accent"
                    @click="showAttendanceList"
                >
                    {{ $t('Anwesenheitsliste anzeigen') }}
                </button>
            </div>
            <kgr-appointment-overrides
                :appointment-prop="appointment"
                :error="error"
                :show-edit="showEdit"
                :instructors="instructors"
                :club-id="clubId"
                @cancel-edit="showEdit = false;"
                @update-appointment="updateAppointment(appointment)"
            />
            <div
                v-if="pending && !showParticipantTable"
                class="kgr-row"
            >
                <kgr-loading inline />
            </div>

            <div
                v-if="showParticipantTable"
                class="kgr-row"
            >
                <kgr-training-appointment-participant-table
                    v-if="accepts.length > 0"
                    ref="acceptedTable"
                    :offering="offering"
                    :bookings="accepts"
                    :headline="headlineAcceptsTable"
                    :pending="pending"
                    :user-id="userId"
                    :table-columns="tableColumns"
                    can-reject
                    @booking-checked="checkBooking($event)"
                    @select-all="toggleSelectAll('accept')"
                    @reject-booking="rejectBooking($event)"
                    @copy-mail-address="copyToClipboard($event, true)"
                />
                <br />
                <kgr-training-appointment-participant-table
                    v-if="rejects.length > 0"
                    ref="rejectedTable"
                    :offering="offering"
                    :bookings="rejects"
                    :headline="headlineRejectsTable"
                    :pending="pending"
                    :user-id="userId"
                    :table-columns="tableColumns"
                    can-accept
                    @booking-checked="checkBooking($event)"
                    @select-all="toggleSelectAll('reject')"
                    @accept-booking="acceptBooking($event)"
                    @copy-mail-address="copyToClipboard($event, true)"
                />
                <br />
                <kgr-training-appointment-participant-table
                    v-if="unsures.length > 0"
                    ref="unsureTable"
                    :offering="offering"
                    :bookings="unsures"
                    :headline="headlineUnsuresTable"
                    :pending="pending"
                    :user-id="userId"
                    :table-columns="tableColumns"
                    can-accept
                    can-reject
                    @booking-checked="checkBooking($event)"
                    @select-all="toggleSelectAll('unsure')"
                    @accept-booking="acceptBooking($event)"
                    @reject-booking="rejectBooking($event)"
                    @copy-mail-address="copyToClipboard($event, true)"
                />
                <br />
                <div class="kgr-postfix__fixed">
                    <a
                        :href="'mailto:?bcc=' + allMails"
                        target="_blank"
                        class="kgr-button kgr-button--accent"
                    >
                        {{ $t('E-Mail an Teilnehmer senden') }}
                    </a>
                    <button
                        class="kgr-button kgr-button--accent"
                        @click="copyToClipboard(allMails)"
                    >
                        {{ $t('E-Mail-Adressen der Teilnehmer kopieren') }}
                    </button>
                    <button
                        name="btn-pdf"
                        class="kgr-button kgr-button--accent"
                        @click="downloadPdf()"
                    >
                        {{ $t('Teilnehmerliste herunterladen (PDF)') }}
                    </button>
                    <button
                        name="btn-pdf"
                        class="kgr-button kgr-button--accent"
                        @click="downloadExcel()"
                    >
                        {{ $t('Teilnehmerliste herunterladen (Excel)') }}
                    </button>
                </div>
            </div>
            <kgr-empty-data
                v-else-if="!pending && offering.registrationRequested && !showEdit && !showAddParticipant"
                :value="$t('Keine Teilnehmer vorhanden')"
            />
            <kgr-empty-data
                v-else-if="!offering.registrationRequested && !showEdit && !showAddParticipant"
                :value="$t('Keine Anmeldung erforderlich')"
            />
        </div>
        <kgr-update-offering-with-notification-modal
            :show-dialog="showCancellationModal"
            :headline="$t('Soll dieses Training storniert werden?')"
            @confirm="onCancellationConfirm"
            @cancel="onCancelCancellation"
        />
        <kgr-update-offering-with-notification-modal
            :show-dialog="showReactivationModal"
            :headline="$t('Soll dieses Training reaktiviert werden?')"
            @confirm="onReactivationConfirm"
            @cancel="onCancelReactivation"
        />
    </kgr-accordion-item>
</template>

<script>
import AccordionItem from '../../common/accordion/AccordionItem.vue';
import AppointmentOverrides from './AppointmentOverrides.vue';
import AppointmentRepository from '../../../js/repository/AppointmentRepository.js';
import EmptyData from '../../common/EmptyData.vue';
import Error from '../../../js/model/Error.js';
import KgrIcon from '../../common/icon/Icon.vue';
import Loading from '../../common/Loading.vue';
import Offering from '../../../js/dto/offering/Offering.js';
import OfferingAppointment from '../../../js/dto/offering/OfferingAppointment.js';
import OfferingLiveSearchResultPreview from '../OfferingLiveSearchResultPreview.vue';
import TrainingAppointmentParticipantTable from './TrainingAppointmentParticipantTable.vue';
import TrainingReply from '../../../js/dto/offering/TrainingReply.js';
import TrainingReplyRepository from '../../../js/repository/TrainingReplyRepository.js';
import UpdateOfferingWithNotificationModal from '../UpdateOfferingWithNotificationModal.vue';
import moment from 'moment';

export default {
    name: 'KgrTrainingAppointmentAccordionItem',
    components: {
        'kgr-accordion-item': AccordionItem,
        'kgr-appointment-overrides': AppointmentOverrides,
        'kgr-empty-data': EmptyData,
        'kgr-icon': KgrIcon,
        'kgr-loading': Loading,
        'kgr-offering-live-search-result-preview': OfferingLiveSearchResultPreview,
        'kgr-training-appointment-participant-table': TrainingAppointmentParticipantTable,
        'kgr-update-offering-with-notification-modal': UpdateOfferingWithNotificationModal,
    },
    props: {
        appointmentProp: {
            type: OfferingAppointment,
            required: true,
        },
        replies: {
            type: Array,
            required: true,
        },
        instructors: {
            type: Array,
            required: true,
        },
        offering: {
            type: Offering,
            required: true,
        },
        clubId: {
            type: Number,
            required: true,
        },
        index: {
            type: Number,
            required: true,
        },
        active: {
            type: Boolean,
            required: true,
        },
        pending: {
            type: Boolean,
            required: true,
        },
        error: {
            type: Error,
            required: true,
        },
        userId: {
            type: Number,
            required: true,
        },
        tableColumns: {
            type: Array,
            required: true,
        },
        searchOpenIndex: {
            type: Number,
            default: null,
        },
    },
    data() {
        return {
            appointment: null,
            loading: false,
            showDetails: false,
            showEdit: false,
            selectAllAccepts: false,
            selectAllUnsures: false,
            selectAllRejects: false,
            checkedBookings: [],
            showAddParticipant: false,
            loadingAddParticipant: false,
            showCancellationModal: false,
            showReactivationModal: false,
        }
    },
    computed: {
        showParticipantTable() {
            return (this.accepts.length > 0 || this.rejects.length > 0 || this.unsures.length > 0) && !this.showEdit && this.active;
        },
        isOverwritten() {
            return this.appointment.hasAppointmentOverride;
        },
        isCancelled() {
            return this.appointment.appointmentOverride && this.appointment.appointmentOverride.isCanceled;
        },
        headlineAcceptsTable() {
            return this.$t('Zusagen ({count})', {count: this.accepts.length});
        },
        headlineRejectsTable() {
            return this.$t('Absagen ({count})', {count: this.rejects.length});
        },
        headlineUnsuresTable() {
            return this.$t('Vielleicht ({count})', {count: this.unsures.length});
        },
        accepts() {
            const accepts = [];
            this.replies.forEach(reply => {
                if (reply.isAccepted()) {
                    reply.checked = this.selectAllAccepts ? true : this.checkedBookings.indexOf(reply.id) > -1;
                    accepts.push(reply);
                }
            });
            return accepts;
        },
        unsures() {
            const unsures = [];
            this.replies.forEach(reply => {
                if (reply.isUnsure()) {
                    reply.checked = this.selectAllUnsures ? true : this.checkedBookings.indexOf(reply.id) > -1;
                    unsures.push(reply);
                }
            });
            return unsures;
        },
        rejects() {
            const rejects = [];
            this.replies.forEach(reply => {
                if (reply.isRejected()) {
                    reply.checked = this.selectAllRejects ? true : this.checkedBookings.indexOf(reply.id) > -1;
                    rejects.push(reply);
                }
            });
            return rejects;
        },
        allMails() {
            const result = [];
            this.accepts.forEach(accept => {
                if (accept.checked) {
                    result.push(accept.member.email);
                }
            });
            this.unsures.forEach(unsure => {
                if (unsure.checked) {
                    result.push(unsure.member.email);
                }
            });
            this.rejects.forEach(reject => {
                if (reject.checked) {
                    result.push(reject.member.email);
                }
            });
            return result.join('; ');
        },
        appointmentTitle() {
            return (this.appointment.appointmentOverride && this.appointment.appointmentOverride.isCanceled ? this.$t('appointment.canceled').toUpperCase() + ': ' : '') + this.$t('weekday_' + this.appointment.weekday) + ', ' +
                this.formattedDateTime(this.appointment.start.date) + ' ' +
                ' - ' +
                (this.formattedDate(this.appointment.start.date) < this.formattedDate(this.appointment.end.date) ? this.formattedDateTime(this.appointment.end.date) : this.formattedTime(this.appointment.end.date))
                + ' ' +
                ' ( ' + this.appointment.acceptedCount + ' / ' + (this.offering.maxParticipants ? this.offering.maxParticipants : 0) + ' )';
        },
        columnQuery() {
            const acceptedCols = this.$refs.acceptedTable ? this.$refs.acceptedTable.getSelectedColumns() : null;
            const rejectedCols = this.$refs.rejectedTable ? this.$refs.rejectedTable.getSelectedColumns() : null;
            const unsureCols = this.$refs.unsureTable ? this.$refs.unsureTable.getSelectedColumns() : null;
            return '?accepted=' + (acceptedCols ? acceptedCols.join(',') : '')
                + '&rejected=' + (rejectedCols ? rejectedCols.join(',') : '')
                + '&unsure=' + (unsureCols ? unsureCols.join(',') : '');
        },
    },
    watch: {
        active() {
            this.toggleAccordion();
        },
        searchOpenIndex(newIndex) {
            if (newIndex !== null && newIndex !== this.index) {
                this.showAddParticipant = false;
            }
        },
    },
    created() {
        this.appointment = this.appointmentProp;
    },
    methods: {
        toggleAccordion() {
            if(!this.active && this.$refs.accordionItem.isOpen) {
                this.$refs.accordionItem.toggle()
            }
        },
        checkBooking(booking) {
            if (booking.checked) {
                this.checkedBookings.push(booking.id);
            } else {
                this.checkedBookings = this.checkedBookings.filter((id) => id !== booking.id);
            }
        },
        toggleSelectAll(select) {
            if('accept' === select) {
                this.selectAllAccepts = !this.selectAllAccepts;
            }
            if('reject' === select) {
                this.selectAllRejects = !this.selectAllRejects;
            }
            if('unsure' === select) {
                this.selectAllUnsures = !this.selectAllUnsures;
            }
        },
        editParticipant(event) {
            event.stopPropagation();
            this.showEdit = false;
            this.showAddParticipant = !this.showAddParticipant;
            if (this.showAddParticipant) {
                this.$emit('openSearch', this.index);
            }
        },
        acceptBookingByMemberId(memberId) {
            this.loadingAddParticipant = true;
            TrainingReplyRepository.createResponse(
                this.clubId,
                memberId,
                this.appointment,
                TrainingReply.RESPONSE_ACCEPTED
            ).then(() => {
                this.$notify.success('Der Teilnehmer wurde hinzugefügt');
                this.showAddParticipant = false;
                this.$emit('updateReplies', this.appointment);
            }).catch((error) => this.$notify.error(error.message))
                .finally(() => this.loadingAddParticipant = false);
        },
        acceptBooking(booking) {
            TrainingReplyRepository.createResponse(
                this.clubId,
                booking.member.id,
                this.appointment,
                TrainingReply.RESPONSE_ACCEPTED
            ).then(() => {
                this.$notify.success('Der Teilnehmer wurde hinzugefügt');
                this.showAddParticipant = false;
                this.$emit('updateReplies', this.appointment);
            })
                .catch((error) => this.$notify.error(error.message));
        },
        rejectBooking(booking) {
            TrainingReplyRepository.createResponse(
                this.clubId,
                booking.member.id,
                this.appointment,
                TrainingReply.RESPONSE_REJECTED
            ).then(() => {
                this.$notify.success('Die Buchung wurde erfolgreich abgesagt');
                this.showAddParticipant = false;
                this.$emit('updateReplies', this.appointment);
            })
                .catch((error) => this.$notify.error(error.message));
        },
        cancelAddParticipant() {
            this.showAddParticipant = false;
        },
        copyToClipboard(content, singleMail = false) {
            if (window.clipboardData && window.clipboardData.setData) {
                return window.clipboardData.setData('Text', content);
            } else if (document.queryCommandSupported && document.queryCommandSupported('copy')) {
                let textarea = document.createElement('textarea');
                textarea.textContent = content;
                textarea.style.position = 'fixed';
                document.body.appendChild(textarea);
                textarea.select();
                try {
                    return document.execCommand('copy');
                } catch (ex) {
                    this.$notify.error('Die Mails konnten nicht in die Zwischenablage kopiert werden');
                } finally {
                    document.body.removeChild(textarea);
                    if (singleMail) {
                        this.$notify.success('{mailAddress} wurde in die Zwischenablage kopiert', {'mailAddress': content });
                    } else {
                        this.$notify.success('Die Mails wurden in die Zwischenablage kopiert');
                    }
                }
            } else {
                this.$notify.error('Die Mails konnten nicht in die Zwischenablage kopiert werden');
            }
        },
        openConfirmReactivationModal() {
            this.showReactivationModal = true;
        },
        onReactivationConfirm(payload) {
            this.showReactivationModal = false;
            this.performReactivation(payload.notifyParticipants, payload.notifyClubEmployees);
        },
        onCancelReactivation() {
            this.showReactivationModal = false;
        },
        performReactivation(notifyParticipants, notifyClubEmployees) {
            this.pendingRemove = true;
            AppointmentRepository.reactivateById(this.appointment, notifyParticipants, notifyClubEmployees)
                .then(() => {
                    this.$notify.success('Der Termin wurde erfolgreich reaktiviert');
                    this.appointment.appointmentOverride.isCanceled = false;
                    this.$emit('updateAppointment', this.appointment);
                })
                .catch(() => this.$notify.error('Der Termin konnte nicht reaktiviert werden'));
        },
        openConfirmCancellationModal() {
            this.showCancellationModal = true;
        },
        onCancellationConfirm(payload) {
            this.showCancellationModal = false;
            this.performCancellation(payload.notifyParticipants, payload.notifyClubEmployees);
        },
        onCancelCancellation() {
            this.showCancellationModal = false;
        },
        performCancellation(notifyParticipants, notifyClubEmployees) {
            this.pendingRemove = true;
            AppointmentRepository.updateCancelById(this.appointment, notifyParticipants, notifyClubEmployees)
                .then(() => {
                    this.$notify.success('Der Termin wurde erfolgreich storniert');
                    this.appointment.appointmentOverride.isCanceled = true;
                    this.$emit('updateReplies', this.appointment);
                })
                .catch(() => this.$notify.error('Der Termin konnte nicht storniert werden'));
        },
        formattedDateTime(date) {
            return moment(date, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY HH:mm');
        },
        formattedDate(date) {
            return moment(date, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD');
        },
        formattedTime(date) {
            return moment(date, 'YYYY-MM-DD HH:mm:ss').format('HH:mm');
        },
        downloadPdf() {
            window.location = `/api/club/training-offering-replies/appointment-series/${this.appointment.appointmentSeries.id}/start/${moment(this.appointment.start.date, 'YYYY-MM-DD HH:mm:ss').format()}/pdf` + this.columnQuery;
        },
        downloadExcel() {
            window.location = `/api/club/training-offering-replies/appointment-series/${this.appointment.appointmentSeries.id}/start/${moment(this.appointment.start.date, 'YYYY-MM-DD HH:mm:ss').format()}/excel`;
        },
        showAttendanceList() {
            window.location = `/backend/appointments/${this.appointment.appointmentSeries.id}/${moment(this.appointment.start.date, 'YYYY-MM-DD HH:mm:ss').format('YYYYMMDDHHmm')}/`;
        },
        updateAppointment(appointment) {
            this.appointment = appointment;
            this.showEdit = false;
        },
        showAttendanceListButton() {
            const today = moment().endOf('day');
            const appointmentDate = moment(this.appointment.start.date, 'YYYY-MM-DD HH:mm:ss');
            return appointmentDate < today;
        },
    }
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
div.row-min-height {
    min-height: 40px;
}
div.row-extra-margin {
    margin-top: 4px;
}
.add-icon {
    font-size: 1.1rem;
    vertical-align: top;
}
.add-icon-user {
    margin-left: -10px;
    font-size: 1.4rem;
}
.clear-icon {
    vertical-align: middle;
}
div.search-container {
    display: inline-block;
    vertical-align: bottom;
    font-size: var(--kgr-font-size-text)
}
</style>
